const WalletType = {
  CREDIT: "credit",
  DEBIT: "debit",
};

export default WalletType;
